var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isActive
    ? _c(
        "div",
        { staticClass: "leaflet-map" },
        [
          _c(
            "l-map",
            {
              staticClass: "leaftlet-map",
              attrs: { center: _vm.centerPoint, zoom: _vm.zoom },
              on: {
                click: function ($event) {
                  return _vm.mapEvent($event)
                },
              },
            },
            [
              _c("LTileLayer", { attrs: { url: _vm.mapUrl } }),
              _c(
                "LMarker",
                {
                  attrs: {
                    "lat-lng": _vm.markerPoint,
                    draggable: _vm.isDraggable,
                  },
                  on: {
                    dragend: function ($event) {
                      return _vm.mapDragged($event)
                    },
                  },
                },
                [
                  _c("LIcon", {
                    attrs: {
                      "icon-url":
                        _vm.settings !== undefined &&
                        _vm.settings.Theme === "A2B"
                          ? require("@/assets/icn_a2b_map_marker.svg")
                          : require("@/assets/icn_map_marker.svg"),
                    },
                  }),
                ],
                1
              ),
              _vm.radius > 0
                ? _c("LCircle", {
                    attrs: {
                      "lat-lng": _vm.markerPoint,
                      radius: _vm.radius * 1000,
                      color:
                        _vm.settings !== undefined &&
                        _vm.settings.Theme === "A2B"
                          ? "#990029"
                          : "#034966",
                      fillOpacity: "0",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }